// Libraries
import { DEFAULT_CURRENCY } from '../../utils/constants/commonValues';
import { getCommDetails } from '../../utils/helperMethods';
import PaySummary from '../../containers/PaymentLink/models/paySummary';
import { Table } from '../';
import BackIcon from '../../static/images/left-arrow.png';
import {
    fetchPaymentsRequest,
    reSharePayLinksRequest,
    viewPayLinksRequest,
} from '../../containers/PaymentLink/redux/paymentLink.actions';
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';

// Utils

// Components

// Styles
import './viewPayments.scss';

const ViewPaymentsActions = ({ viewPay, data, reSharePayLinksRequest }) => {
    // Get Communication details from data
    const commDetails = getCommDetails(data.original);
    const handleOpenActionPopup = actionType => {
        if (!isEmpty(commDetails)) {
            const request = {
                linkId: data.original.sharedLinkId,
            };
            reSharePayLinksRequest(request);
        }
    };

    return (
        <div className="userAction multiItem">
            <button
                className={`share ${
                    isEmpty(commDetails) ||
                    (viewPay &&
                        viewPay.summaryData &&
                        viewPay.summaryData.linkDataStatus === 'INACTIVE')
                        ? 'disabled'
                        : ''
                }`}
                onClick={() => handleOpenActionPopup('share')}
            />
        </div>
    );
};

const PaymentLinkHeader = props => {
    const { data, error, actions } = props;
    const payValues = new PaySummary(data);

    const history = useHistory();
    const { linkDataId } = useParams();

    // Handle Url change for payment link transaction view summary.
    useEffect(() => {
        const request = {
            linkDataId,
        };
        actions.viewPayLinksRequest(request);
    }, [actions, linkDataId]);

    const onBack = () => {
        history.push('/payment-link');
    };

    return (
        <div className="payment-list-header">
            <div className="search-wrap">
                <div className="search-title">
                    <button
                        type="submit"
                        className="back-icon"
                        onClick={onBack}
                    >
                        <img src={BackIcon} alt="Back" />
                    </button>
                    <h3>{payValues.linkName}</h3>
                    <label className="search-breadCrumb">
                        Payment Links &gt; {payValues.linkName}
                    </label>
                </div>
            </div>
            {error && error.errorMessage ? (
                <div className="not-found">{error.errorMessage}</div>
            ) : (
                <ul className="search-item">
                    <li>
                        <p className="item-head">Link ID</p>
                        <p className="item-value">
                            {payValues.linkDataId || linkDataId || '-'}
                        </p>
                    </li>
                    <li>
                        <p className="item-head">Amount</p>
                        <p className="item-value">
                            {payValues.amount &&
                                `${DEFAULT_CURRENCY} ${payValues.amount}`}
                        </p>
                    </li>
                    <li>
                        <p className="item-head">Created On</p>
                        <p className="item-value">{payValues.createdOn}</p>
                    </li>
                    <li>
                        <p className="item-head">Validity Period</p>
                        <p className="item-value">{payValues.validityPeriod}</p>
                    </li>
                    <li className="issueBank">
                        <p className="item-head">Shared Count</p>
                        <p className="item-value">
                            {payValues.sharedCount || '-'}
                        </p>
                    </li>
                    <li>
                        <p className="item-head">Trans. Success</p>
                        <p className="item-value">
                            {payValues.txnSuccessCount}
                        </p>
                    </li>
                    <li>
                        <p className="item-head">Status</p>
                        <p className="item-value">
                            <span
                                className={`status ${payValues.linkDataStatus}`}
                            />
                            {payValues.linkDataStatus}
                        </p>
                    </li>
                </ul>
            )}
        </div>
    );
};

const ViewPayments = props => {
    const {
        paymentLinkData,
        staticData,
        actions,
        tableFilters,
        filterData,
        loader: { showLoader },
    } = props;

    const {
        error,
        tableDataTxn,
        isLoading,
        paginationTxn,
        viewPay,
    } = paymentLinkData;

    const { linkDataId } = useParams();

    // We'll start our table without any data
    const [pageCount, setPageCount] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [isResetPage, setIsResetPage] = useState(false);

    const pageSizeOptions = [10, 20, 40, 60];

    const columns = useMemo(
        () => [
            {
                header: 'Mobile / Email Id ',
                accessor: 'communicationModeValue',
            },
            { header: 'Share Date', accessor: 'sharedDate' },
            { header: 'Status', accessor: 'transactionStatusView' },
            { header: 'Transaction ID', accessor: 'transactionId' },
            { header: 'Transaction Date', accessor: 'transactionDate' },
            { header: 'Payment Mode', accessor: 'paymentMode' },
            { header: 'Action', accessor: 'action' },
        ],
        []
    );

    // Fetching  table data for payment link transaction view table.
    const fetchDataPayments = useCallback(
        ({ pageSize, pageIndex }) => {
            // This will get called when the table needs new data
            // You could fetch your data from literally anywhere,
            const data = {
                pageSize,
                pageIndex,
                linkDataId,
            };
            actions.fetchPaymentsRequest({ ...data, ...filterData });
            setPageSize(pageSize);
        },
        [actions, filterData, linkDataId]
    );

    // Handle Pagination for the table
    useEffect(() => {
        setPageCount(Math.ceil(paginationTxn.totalNumberOfRecords / pageSize));
    }, [pageSize, paginationTxn.totalNumberOfRecords]);

    return (
        <div className="payment-link-wrapper">
            <PaymentLinkHeader
                actions={actions}
                data={viewPay}
                error={viewPay.error || ''}
            />
            <Table
                columns={columns}
                isFiltersEnable
                isPaginationEnable
                filterData={filterData}
                data={tableDataTxn}
                tableHead={null}
                error={error && error.errorMessage}
                loading={showLoader || isLoading}
                pageCount={pageCount}
                fetchData={fetchDataPayments}
                numberOfRecord={paginationTxn.totalNumberOfRecords}
                pageSizeOptions={pageSizeOptions}
                paginationLabel="Rows per page"
                pagePerView={3}
                isResetPage={isResetPage}
                afterResetPage={() => setIsResetPage(false)}
                userActions={data => (
                    <ViewPaymentsActions
                        data={data}
                        viewPay={viewPay}
                        staticData={staticData.payValues}
                        reSharePayLinksRequest={actions.reSharePayLinksRequest}
                        fetchData={fetchDataPayments}
                        resetPage={() => setIsResetPage(true)}
                    />
                )}
                tableFilters={tableFilters}
            />
        </div>
    );
};

const mapStateToProps = ({ auth, paymentLinkData, loader, staticData }) => ({
    auth,
    paymentLinkData,
    staticData,
    loader,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchPaymentsRequest,
            reSharePayLinksRequest,
            viewPayLinksRequest,
        },
        dispatch
    ),
});

ViewPayments.propTypes = {
    actions: PropTypes.object,
    handleSubmit: PropTypes.func,
    closePopup: PropTypes.func,
    data: PropTypes.object,
    filterData: PropTypes.string,
    paymentLinkData: PropTypes.object,
    loader: PropTypes.object,
    staticData: PropTypes.object,
    tableFilters: PropTypes.node,
};

ViewPaymentsActions.propTypes = {
    data: PropTypes.object,
    viewPay: PropTypes.object,
    staticData: PropTypes.object,
    fetchData: PropTypes.func,
    resetPage: PropTypes.func,
    reSharePayLinksRequest: PropTypes.func,
};

PaymentLinkHeader.propTypes = {
    data: PropTypes.object,
    actions: PropTypes.object,
    error: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPayments);
